import {Order, OrderItem, Store} from 'aigens-ng-core';
import {MobileBasePage} from '../../../core/base/mobile-base-page';
import {Component, Injector, OnInit} from '@angular/core';
import {SurveyDialog} from '../../../dialogs/survey/survey';
import {currentTimeString, timeStringLabel} from '../../../shared/utilities/checkFormatTool';
import {preloaderFinished} from '../../../../preloader';

/*
  Generated class for the ByodSummary page.

  See http://ionicframework.com/docs/v2/components/#navigation for more info on
  Ionic pages and navigation.
*/
declare var genkiJSInterface: any;

@Component({
    selector: 'page-byod-summary',
    templateUrl: 'byod-summary.html',
    styleUrls: ['byod-summary.scss']
})
export class ByodSummaryPage extends MobileBasePage implements OnInit {

    orders: Order[];
    ordersMap = {};
    listExpand: {} = {};
    loadingTime: string;
    session: string;
    deliveryTime: string;
    firstTime = true;
    hasProblem = false;
    printerDisconnect = false;
    listening = false;
    hiddenGrandTotal = false;
    printerStatus = {};
    orderStatusDisplayMap = {};

    showSurveyBox = true;

    addInfo: any;
    isPrinterOffline = false;
    isIsolate: boolean;

    constructor(injector: Injector) {

        super(injector);
        this.loadingTime = currentTimeString();
        this.session = this.getNavParams('sessionId');
        this.isIsolate = this.getNavParams('isIsolate');
        console.log('this.isIsolate', this.isIsolate);
        this.hiddenGrandTotal = this.orderService.hideTotal;
        if (!this.session) {
            this.session = this.orderService.session;
        } else if (!this.orderService.session) {
            this.orderService.session = this.session;
        }

        const host = window.location.host;
        if (host === 'bksg.order.place') {
            this.orderService.isBK = true;
        }

        if (this.orderService.isBK && !this.session) {
            this.session = '1234';
        }
        if (!this.orderService.surveyUrl) {
            this.showSurveyBox = false;
        }

        if (this.orderService.store) {
            let store = this.orderService.store;
            try {
                if (store.brand && store.brand['config'] && store.brand['config'][0] && store.brand['config'][0]['general']) {
                    this.orderStatusDisplayMap = store.brand['config'][0]['general'];
                }
            } catch (error) {
                console.error(`error in store.brand["config"][0]["general"];`);

            }

        }
        this.addInfo = Store.getPickUpInfo(this.orderManager.store);
        window.history.replaceState({}, 'Order.Place', this.navigationService.getRootPageUrl());
    }

    static getPageUrl() {
        return 'byod-summary';
    }

    ngOnInit() {

        super.ngOnInit();
        if (this.browserService.isBKApp()) {
            console.log('exit webview');
            genkiJSInterface.exitwebview();
        }

        if (!this.orders) {
            this.getOrders();
        }

        console.log('surveyExtBrowser', this.orderService.surveyExtBrowser);
    }

    ionViewWillLeave() {
        super.ionViewWillLeave();
        this.monitoringService.unlistenAll();
    }

    getOrders(refresher?): void {


        if (this.isCalledIn(5000)) {
            this.loading(false);
            if (refresher) {
                refresher.complete();
            }
            return;
        }

        let spot = this.orderService.spot;
        let storeId = this.orderService.storeId;
        let deviceId = this.sessionService.getDeviceId();
        let mode = this.orderManager.mode;
        let session = this.orderService.session;
        if (!storeId) {
            storeId = this.getNavParams('store');
            this.orderService.storeId = storeId;
        }
        if (!spot) {
            spot = this.getNavParams('spot');
            this.orderService.spot = spot;
        }
        if (!mode) {
            mode = this.getNavParams('mode');
            this.orderManager.mode = mode;
        }
        if (!session) {
            session = this.getNavParams('key');
            if (!session) {
                session = this.getNavParams('session');
            }
            this.orderService.session = session && session !== '0' ? session : null;
        }


        this.orderService.deviceId = this.sessionService.getDeviceId();

        if (!this.orderService.session && !this.orderService.preOrder && this.orderService.storeId) {
            let paid = true; // force to true for getting session
            this.genSetSession(this.orderService.storeId.toString(), paid ? () => {
                this.getOrderFlow(this.orderService.spot, this.orderService.storeId, this.orderManager.mode, this.orderService.deviceId, refresher);
            } : null);
        } else {
            this.getOrderFlow(this.orderService.spot, this.orderService.storeId, this.orderManager.mode, this.orderService.deviceId, refresher);
        }


    }

    getOrderFlow(spot: any, storeId: any, mode: any, deviceId: any, refresher: any = null) {
        if (this.orderService.isBK) {
            this.orderService.getBKOrders(this.session).subscribe(
                orders => {
                    if (refresher) {
                        refresher.complete();
                    }
                    this.loadingTime = currentTimeString();
                    this.orders = this.orderService.isBK ? orders : this.sortingOrder(orders);
                    console.log(orders);

                    if (this.orders) {
                        this.orders.forEach(order => {
                            if (this.listExpand[order.id] === null) {
                                this.listExpand[order.id] = false;
                            }

                            if (order.orderitems) {
                                order.orderitems.forEach(oi => {
                                    OrderItem.flattenItems(oi);
                                });
                            }
                            if (order.pickup) {
                                order['pickupTimeLabel'] = timeStringLabel(order.pickup);

                            }

                            /*if (order["deliveryTime"]){
                                order["deliveryTimeLabel"] = order["deliveryTime"].replace("T"," ").replace(":00.000","");
                            }*/

                            /*if (order["address"]) {
                                order["addressString"] = this.getAddressString(order);
                            }*/

                        });
                        if (this.orders.length === 1) {
                            this.listExpand[orders[0].id] = true;
                        }

                    }
                    this.loading(false);
                },
                err => {
                    this.loading(false);
                    if (refresher) {
                        refresher.complete();
                    } else {
                        this.showError(err);
                    }
                    this.loadingTime = currentTimeString();
                    console.log(err);
                },
                () => {
                    this.loading(false);
                    preloaderFinished();

                }
            );

        } else if (this.isIsolate) {
            this.loading(true);
            this.orderService.getOrders(this.session).subscribe(orders => {

                    if (refresher) {
                        refresher.complete();
                    }

                    this.loadingTime = currentTimeString();

                    this.loading(false);
                    this.orders = orders;
                    this.orders.sort((a, b) => {
                        if (a.create < b.create) {
                            return 1;
                        }
                        if (a.create > b.create) {
                            return -1;
                        }

                        return 0;
                    });
                    console.log(orders);

                    if (this.orders) {
                        // listen to firebase
                        this.handleFirebaseOrderStatus();

                        let hasSendingOrder = false;
                        this.orders.forEach(order => {
                            // console.log('this.oreder[i] ###',order);
                            // add a local flag to control ui css
                            if (order.type === 'delivery') {
                                order['stayStatusIndex'] = this.getStayIndex(order);
                            }

                            if (order.orderitems) {
                                order.orderitems.forEach(oi => {
                                    // oi.makeFlatItems();
                                    OrderItem.flattenItems(oi);

                                });

                                order.orderitems = order.orderitems.reverse();
                                this.patchTime(order.orderitems);


                            }

                            this.ordersMap[order.id] = order;
                            if (this.listExpand[order.id] === null) {
                                // ???
                                this.listExpand[order.id] = false;
                            }

                            // if(this.orderService.store && (this.orderService.store.id === 5669108628586496 || this.orderService.store.id === 5143146715414528)){

                            if (order.status === 'sending' && !this.listening) {
                                this.listening = true;
                                hasSendingOrder = true;
                                this.monitoringService.listenStoreStarPrintStatus(this.orderService.storeId, (result) => {
                                    // var status = result["status"]["status"];
                                    if (result) {

                                        if (result['status']) {
                                            this.printerStatus[result['ip']] = result['status'];

                                        } else {
                                            for (const key in result) {
                                                this.printerStatus[result[key]['ip']] = result[key]['status'];
                                                this.listenOrder(result[key]['ip'], order);
                                            }


                                        }
                                        this.isStarPrinterOffline();
                                    }

                                });
                            } else if (order.status === 'sending') {
                                hasSendingOrder = true;
                            }
                            // }

                        });

                        // if(this.orderService.store && (this.orderService.store.id === 5669108628586496 || this.orderService.store.id === 5143146715414528)){

                        if (!hasSendingOrder && this.listening) {
                            this.stopListenPrinter();

                        }

                        this.isStarPrinterOffline();

                        // }


                        if (this.orders.length > 0) {
                            this.listExpand[orders[0].id] = true;
                            this.orders[0].storeId;
                            this.systemConfigService.getSystemConfig(this.orders[0].storeId, (data) => {
                                console.log('data', data);
                                this.themeService.setConfigTheme(data['data'] ? data['data']['colors'] : null);
                            });
                        } else {
                            this.themeService.setConfigTheme({dummy: true});
                        }
                    }
                },
                err => {
                    if (refresher) {
                        refresher.complete();
                    }
                    this.loadingTime = currentTimeString();
                    console.log(err);
                    this.showError(err);
                    this.loading(false);
                },
                () => {
                    if (refresher) {
                        refresher.complete();
                    }
                    preloaderFinished();
                    this.loadingTime = currentTimeString();
                    this.loading(false);
                });
        } else {
            if (this.firstTime) {
                this.firstTime = false;
                this.loading(true);

            }
            this.orderService.getByodOrders(storeId, spot, deviceId).subscribe(
                orders => {

                    if (refresher) {
                        refresher.complete();
                    }

                    this.loadingTime = currentTimeString();

                    this.loading(false);
                    this.orders = orders;
                    this.orders.sort((a, b) => {
                        if (a.create < b.create) {
                            return 1;
                        }
                        if (a.create > b.create) {
                            return -1;
                        }

                        return 0;
                    });
                    console.log(orders);

                    if (this.orders) {
                        // listen to firebase
                        this.handleFirebaseOrderStatus();

                        let hasSendingOrder = false;
                        this.orders.forEach(order => {
                            // console.log('this.oreder[i] ###',order);
                            // add a local flag to control ui css
                            if (order.type === 'delivery') {
                                order['stayStatusIndex'] = this.getStayIndex(order);
                            }

                            if (order.orderitems) {
                                order.orderitems.forEach(oi => {
                                    // oi.makeFlatItems();
                                    OrderItem.flattenItems(oi);

                                });

                                order.orderitems = order.orderitems.reverse();
                                this.patchTime(order.orderitems);


                            }

                            this.ordersMap[order.id] = order;
                            if (this.listExpand[order.id] === null) {
                                // ???
                                this.listExpand[order.id] = false;
                            }

                            // if(this.orderService.store && (this.orderService.store.id === 5669108628586496 || this.orderService.store.id === 5143146715414528)){

                            if (order.status === 'sending' && !this.listening) {
                                this.listening = true;
                                hasSendingOrder = true;
                                this.monitoringService.listenStoreStarPrintStatus(this.orderService.storeId, (result) => {
                                    // var status = result["status"]["status"];
                                    if (result) {

                                        if (result['status']) {
                                            this.printerStatus[result['ip']] = result['status'];

                                        } else {
                                            for (const key in result) {
                                                this.printerStatus[result[key]['ip']] = result[key]['status'];
                                                this.listenOrder(result[key]['ip'], order);
                                            }


                                        }
                                        this.isStarPrinterOffline();
                                    }

                                });
                            } else if (order.status === 'sending') {
                                hasSendingOrder = true;
                            }
                            // }

                        });

                        // if(this.orderService.store && (this.orderService.store.id === 5669108628586496 || this.orderService.store.id === 5143146715414528)){

                        if (!hasSendingOrder && this.listening) {
                            this.stopListenPrinter();

                        }

                        this.isStarPrinterOffline();

                        // }


                        if (this.orders.length > 0) {
                            this.listExpand[orders[0].id] = true;
                        }
                    }
                },
                err => {
                    if (refresher) {
                        refresher.complete();
                    }
                    this.loadingTime = currentTimeString();
                    console.log(err);
                    this.showError(err);
                    this.loading(false);
                },
                () => {
                    if (refresher) {
                        refresher.complete();
                    }
                    preloaderFinished();
                    this.loadingTime = currentTimeString();
                    this.loading(false);
                }
            );

        }
    }

    // todo adjust the return-val accoding the case
    getStayIndex(order: Order): number {
        if (order && order['deliveryStatus']) {
            let status = order['deliveryStatus'];
            switch (status) {
                case 'pending':
                    return 0;
                case 'paying':
                    return 0;
                case 'accepted':
                    return 1;
                case 'rejected':
                    return 0;
                case 'allocated':
                    return 1;
                case 'picked':
                    return 2;
                case 'arrived':
                    return 3;
                case 'delivered':
                    return 3;
                case 'cancelled':
                    return 0;
                case 'failed':
                    return 0;
            }
        } else {
            return 0;
        }

    }

    handleFirebaseOrderStatus() {

        let str = null;

        for (let order of this.orders) {
            if (order && order['statusUrl']) {
                str = order['statusUrl'].toString();
                // prd aigensstoreapp.firebaseapp.com
                let indexOfUpdate = str.indexOf('update');
                let res = str.slice(indexOfUpdate, str.length - 5);
                // let lastIndex = res.lastIndexOf('/');
                // var res2 = res.slice(0, lastIndex + 1);
                // console.log('resres', res2);


                if (order && str) {
                    this.monitoringService.listenOrderStatus2(res, (current) => {

                    }, (update) => {
                        console.log('update detected', update);

                        if (update) {
                            order.status = update['status'];
                            if (order.type === 'delivery') {
                                console.log('delivery listenOrder data.deliveryStatus:', update['deliveryStatus']);
                                order['deliveryStatus'] = update['deliveryStatus'];
                                order['stayStatusIndex'] = this.getStayIndex(order);
                                // console.log('this.orders',this.orders);
                            }
                        }


                    }, () => {
                    });
                }
            }
        }

        // flag control
        if (this.systemConfigService.showOrderQueue) {
            this.checkFirebaseStoreOrders();
        }
    }

    // flag control
    checkFirebaseStoreOrders() {
        if (this.orders && this.orders.length > 0) {
            let order = this.orders[0];
            let str = order['statusUrl'].toString();
            // prd aigensstoreapp.firebaseapp.com
            let indexOfUpdate = str.indexOf('update');
            let res = str.slice(indexOfUpdate, str.length - 5);
            let lastIndex = res.lastIndexOf('/');
            let res2 = res.slice(0, lastIndex);
            console.log('resres', res2);

            if (order && res2) {
                this.monitoringService.listenStoreOrder(res2, (current) => {
                    // console.log("orders first view detected",current);
                    let storeOrders = current;
                    for (let o of this.orders) {
                        // reset all
                        o['orderQueue'] = 0;
                        for (let sOrderId in storeOrders) {
                            if (o.create > storeOrders[sOrderId].create && storeOrders[sOrderId].status === 'received') {
                                if (o['orderQueue']) {
                                    o['orderQueue'] += 1;
                                } else {
                                    o['orderQueue'] = 1;
                                }
                            }
                        }
                    }
                }, (update) => {
                    // console.log("orders update detected", update);

                    // if (update) {
                    //     for (let order of this.orders) {
                    //         if(update.create < order.create && update.status != 'received')
                    //         {
                    //             if(order['orderQueue'])
                    //             {
                    //                 order['orderQueue'] -= 1;
                    //             }
                    //         }
                    //     }
                    // }


                }, (del) => {
                    // console.log("orders del detected",del);
                });
            }
        }
    }

    listenOrders(printAddress: string) {
        if (printAddress && this.orders) {
            this.orders.forEach((order) => {
                if (order.status === 'sending' && !this.monitoringService.isOrderMonitoring(order.orderNo)) {
                    this.monitoringService.listenPrinterOrder(printAddress, order.orderNo, (data) => {
                        console.log('changed');
                        console.log(data);
                        if (data.value) {
                            this.firebaseAssignValue(order.id, data.type, data.value);

                        } else {
                            const result = data.type === 'status' ? 'completed' : null;

                            this.firebaseAssignValue(order.id, data.type, result);

                            if (result) {
                                this.monitoringService.unlistenOrderPair(order.orderNo, () => {
                                    if (this.monitoringService.numberOfRefs <= 1) {
                                        this.stopListenPrinter();
                                    }
                                });


                            }
                        }

                    });

                }
            });
        }

    }

    getOrderStatusDisplay(order: any) { // 使用serve传来的订单状态display
        const lang = this.t.currentLang;
        let statusDisplay = '';
        if (lang.startsWith('zh')) {
            if (this.orderStatusDisplayMap && this.orderStatusDisplayMap[order.status] && this.orderStatusDisplayMap[order.status]['nameZh'] &&
                this.orderStatusDisplayMap[order.status]['nameZh'] !== '') {
                statusDisplay = this.orderStatusDisplayMap[order.status]['nameZh'];
                return statusDisplay;
            } else {
                const translateWord = 'status.' + order.type + '.' + order.status;
                statusDisplay = this.t.instant(translateWord);
                return statusDisplay;
            }
        } else if (lang === 'en') {
            if (this.orderStatusDisplayMap && this.orderStatusDisplayMap[order.status] && this.orderStatusDisplayMap[order.status]['nameEn'] &&
                this.orderStatusDisplayMap[order.status]['nameEn'] !== '') {
                statusDisplay = this.orderStatusDisplayMap[order.status]['nameEn'];
                return statusDisplay;
            } else {
                const translateWord = 'status.' + order.type + '.' + order.status;
                statusDisplay = this.t.instant(translateWord);
                return statusDisplay;
            }
        } else {
            const translateWord = 'status.' + order.type + '.' + order.status;
            statusDisplay = this.t.instant(translateWord);
            return statusDisplay;
        }
    }

    listenOrder(printAddress: string, order: Order) {
        if (printAddress && order) {
            if (!this.monitoringService.isOrderMonitoring(order.orderNo)) {
                this.monitoringService.listenPrinterOrder(printAddress, order.orderNo, (data) => {
                    console.log('changed');
                    console.log(data);
                    if (data.value) {
                        this.firebaseAssignValue(order.id, data.type, data.value);

                    } else {
                        const result = data.type === 'status' ? 'completed' : null;

                        this.firebaseAssignValue(order.id, data.type, result);

                        if (result && order.type !== 'delivery') {
                            this.monitoringService.unlistenOrderPair(order.orderNo, () => {
                                if (this.monitoringService.numberOfRefs <= 1) {
                                    this.stopListenPrinter();
                                }
                            });


                        }
                    }

                });

            }
        }

    }

    firebaseAssignValue(id: string, type: string, value: string) {
        if (type === 'status') {
            this.ordersMap[id].status = value;

        } else {
            this.ordersMap[id].error = value;

        }
    }

    stopListenPrinter() {
        this.listening = false;
        console.log('stop listen1', this.hasProblem);
        this.hasProblem = false;
        console.log('stop listen2', this.hasProblem);
        this.printerStatus = {};
        this.monitoringService.unlistenAll();
    }

    patchTime(orderitems: OrderItem[]) {

        let lastTime = null;

        for (const oi of orderitems) {

            const thisTime = oi.create;

            if (thisTime === lastTime) {
                oi.create = null;
            }

            lastTime = thisTime;
        }

    }


    orderClicked(order: Order) {
        console.log('this.order', order);
        if (order.payment === 'cash' && order.status !== 'pending' && order.status !== 'paying') {
            console.log('order.status', order.status);
            return;
        }
        if (order.type === 'prekiosk' && order.status !== 'paid' && order.status !== 'cancelled') {
            this.pushByName('OrderStatusPreKioskPage', {qrData: order['id'], order, ifSessionId: false});
            // this.navController.push(OrderStatusPreKioskPage, { order: order });
        } else if (order.payments && order.payments.length > 0) {
            // TODO: unify qrcode handlment with base cart page
            if (order.payments[0].type === 'cash') {
                if (order.payments[0].gateway === 'delaypayment') {
                    let qrdata: string = (order && order['extra'] && order['extra']['posBackendId']);
                    if (qrdata) {
                        qrdata = 'TMPOR' + qrdata;
                    }
                    // this.navController.push(OrderQrCodePage, { qrData: qrdata, ifSessionId: false });
                    this.pushByName('QrCodePage', {qrData: qrdata, order: order, ifSessionId: false});
                } else if (order.payments[0].gateway === 'cash' || order.payments[0].gateway === 'pos') {
                    // this.navController.push(OrderQrCodePage, { qrData: order.id, ifSessionId: false });
                    this.pushByName('QrCodePage', {qrData: order['id'], order: order, ifSessionId: false, goBackUrl: 'byod-summary'});

                }
            } else if (order.payments[0].type === 'delay') {
                let qrdata: string = (order && order['qrcode']);
                this.pushByName('QrCodePage', {qrData: qrdata, order: order, ifSessionId: false});
                // this.navController.push(OrderQrCodePage, { qrData: qrdata, ifSessionId: false });
            }
        }
    }

    // payCashClicked(order) {
    //     console.log('payCashClicked:', order);
    //     this.pushByName('QrCodePage', { qrData: order['id'], ifSessionId: false, goBackUrl: 'byod-summary' }, ).then(() => {
    //         this.orderService.clear();
    //         if (this.navParams.get('fromSplash')) {
    //             this.orderManager.clear();
    //         }
    //     });
    // }
    isStarPrinterOffline() {
        if (Object.keys(this.printerStatus).length > 0 && this.listening) {
            let noProblem = true;
            let disconnect = false;
            const currentTime = new Date().getTime();
            for (const key in this.printerStatus) {
                if (this.printerStatus[key]['status'] === 'offline') {
                    noProblem = false;
                    break;
                }

                noProblem = true;

            }

            for (const key in this.printerStatus) {
                if (currentTime - this.printerStatus[key]['datetime'] > 2.5 * 60000) {
                    noProblem = false;
                    disconnect = true;
                    break;
                }

                disconnect = false;

            }
            this.printerDisconnect = disconnect;
            console.log('1is Offline?', this.isPrinterOffline);
            this.isPrinterOffline = !noProblem;
            console.log('2is Offline?', this.isPrinterOffline);

            return this.isPrinterOffline;
        }
    }

    async doRefresh(refresher?: Event, isRefreshButton: boolean = false) {

        // do not call api every x second

        // if (refresher || isRefreshButton) {
        //     await this.loading(true);
        // }
        // if (refresher) {
        //     this.getOrders(refresher.target);
        // } else {
        //     this.getOrders();
        // }
    }

    getUIRefreshInterval(): number {
        // if(this.orderService.store && this.orderService.store.id === 5669108628586496){
        //     return 0;
        // }else{
        return 10000;
        // return 0;
        // }
    }

    onRefreshUI() {
        console.log('refresh ui');
        if (this.orders && this.orders.length > 0 && this.orders[0].type && this.orders[0].type !== 'byod') {
            this.doRefresh();
        }
    }

    // TO-DO expand only that list
    clickToExpand(index: string) {
        this.listExpand[index] = !this.listExpand[index];
    }


    getAddressString(order: Order) {
        let addressString;
        for (const key in order['address']) {
            if (order['address'][key]) {

                addressString = addressString === null ? order['address'][key] : (addressString + ',' + order['address'][key]);
            }
        }

        return addressString;
    }

    sortingOrder(orders: Order[]): Order[] {
        let tmp: Order[] = [];
        const pending: Order[] = [];
        const ready: Order[] = [];
        const received: Order[] = [];
        const paid: Order[] = [];
        const completed: Order[] = [];

        orders.forEach((order) => {
            if (order.status === 'ready') {
                ready.push(order);
            } else if (order.status === 'ready') {
                ready.push(order);
            } else if (order.status === 'received') {
                received.push(order);
            } else if (order.status === 'paid') {
                paid.push(order);
            } else if (order.status === 'completed') {
                completed.push(order);
            }
        });
        if (pending.length > 0) {
            tmp = tmp.concat(pending);
        }
        if (ready.length > 0) {
            tmp = tmp.concat(ready);
        }
        if (received.length > 0) {
            tmp = tmp.concat(received);
        }
        if (paid.length > 0) {
            tmp = tmp.concat(paid);
        }
        if (completed.length > 0) {
            tmp = tmp.concat(completed);
        }

        return tmp;
    }

    isSet(oi: OrderItem) {
        return OrderItem.isSet(oi);
    }

    discloseSurvey() {
        this.showSurveyBox = false;
    }

    async createSurvey() {
        console.log('created');
        const input = {store: this.orderManager.store};
        const modal = await this.modalController.create({
            component: SurveyDialog,
            componentProps: input,
            showBackdrop: true,
            backdropDismiss: true,
            cssClass: 'no-bgColor'
        });
        modal.present();
        this.showSurveyBox = false;
    }

    public pageName(): string {
        return '/byod-summary';
    }

}
